import { useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LanguageSelector from "../translation/LanguageSelector";
import { FaHome, FaChevronLeft, FaUtensils } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export const Header = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const headerRef = useRef(null);
    const isHome = location.pathname === "/home" || location.pathname === "/";

    const navItems = [
        { id: 'home', to: "/home", icon: <FaHome />, label: t("nav.home"), isActive: isHome },
        { id: 'menu', to: "/menu", icon: <FaUtensils />, label: t("nav.menu"), isActive: location.pathname === "/menu" },
    ];

    // Publish the real header height so sticky bars further down the page (the menu's
    // category bar) can park exactly underneath it - it is taller than 64px once the
    // safe-area inset or the desktop frame padding is added.
    useEffect(() => {
        const publish = () => {
            const h = headerRef.current?.offsetHeight;
            if (h) document.documentElement.style.setProperty("--app-header-h", `${h}px`);
        };
        publish();
        window.addEventListener("resize", publish);
        return () => window.removeEventListener("resize", publish);
    }, []);

    return (
        <>
            {/* Top Bar */}
            <header ref={headerRef} className="fixed top-0 left-0 w-full z-50 bg-white/80 backdrop-blur-xl border-b border-slate-100 px-4 safe-top lg:pt-8 transition-all">
                <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
                    <div className="flex items-center gap-3">
                        {!isHome && (
                            <button
                                onClick={() => navigate(-1)}
                                className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-50 text-slate-600 active:bg-slate-200 transition-colors"
                            >
                                <FaChevronLeft size={16} />
                            </button>
                        )}
                        <Link to="/home" className="text-xl font-clash text-slate-900 tracking-tighter">
                            HIRA
                        </Link>
                    </div>

                    <div className="flex items-center">
                        <LanguageSelector />
                    </div>
                </div>
            </header>

            {/* Bottom Nav: The standard for Mobile Apps */}
            <nav className="fixed bottom-0 left-0 w-full z-50 bg-white/90 backdrop-blur-xl border-t border-slate-100 safe-bottom lg:pb-6 transition-all">
                <div className="flex items-center justify-around h-16 max-w-7xl mx-auto px-2">
                    {navItems.map((item) => (
                        <Link
                            key={item.to}
                            to={item.to}
                            className={`flex flex-col items-center justify-center gap-1 min-w-[3.5rem] transition-all duration-300 ${item.isActive ? 'text-brand-600' : 'text-slate-400'
                                }`}
                        >
                            <div className={`text-xl transition-transform duration-300 ${item.isActive ? 'scale-110' : ''}`}>
                                {item.icon}
                            </div>
                            <span className="text-[10px] font-bold tracking-tight text-center whitespace-nowrap overflow-hidden max-w-[4rem]">
                                {item.label}
                            </span>
                        </Link>
                    ))}
                </div>
            </nav>
        </>
    );
};
